import React from 'react'
import { Layout } from 'react-admin'
import MyAppBar from './MyAppBar'
import { ProfileProvider } from '../pages/profile'
// import Menu from './Menu/Menu'

const MyLayout = (props) => (
  <ProfileProvider>
    {/*<Layout {...props} appBar={MyAppBar} menu={Menu} />*/}
    <Layout {...props} appBar={MyAppBar} />
  </ProfileProvider>
)

export default MyLayout
